<template>
  <div class="resp_container">
    <div class="add_response">
      <v-alert type="success" variant="outlined" v-if="success">
        Thank you! Your submission was successful! You will hear from us
        shortly, also, the website is under maintenance and will have more
        information soon. Please feel free to check back frequently for updates!
      </v-alert>
      <v-alert type="error" variant="outlined" v-if="error">
        There was an error with your submision. Please try again later.
      </v-alert>
      <!-- Begin Form-->
      <v-form
        class="mb-10"
        v-on:submit.prevent="submitForm"
        v-model="isFormValid"
      >
        <v-container>
          <v-row>
            <v-col>
              <h4>
                Please fill out the form below. If you have a second player,
                please check the second player box.
              </h4>
              <h3>
                ALL fields are required EXCEPT for the second player field.
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="first"
                :rules="[rules.required]"
                v-model="first"
                placeholder="First Name"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="last"
                :rules="[rules.required]"
                v-model="last"
                placeholder="Last Name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                :class="{ invalid: isValid == 1 }"
                id="phone"
                :rules="[rules.required]"
                v-model="phone"
                placeholder="Phone"
                @keyup="validatePhone(phone, 'phone')"
              >
              </v-text-field>
              <div class="invalid-warning" v-if="isValid == 1">
                Invalid phone number!
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="email"
                class="form-control"
                id="email"
                :rules="[rules.required, rules.email]"
                v-model="email"
                placeholder="Email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="pFirst"
                :rules="[rules.required]"
                v-model="pFirst"
                placeholder="Parent First"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="pLast"
                :rules="[rules.required]"
                v-model="pLast"
                placeholder="Parent Last"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                :class="{ invalid: isValid == 2 }"
                id="pPhone"
                :rules="[rules.required]"
                v-model="pPhone"
                placeholder="Parent Phone"
                @keyup="validatePhone(pPhone, 'parent')"
              >
              </v-text-field>
              <div class="invalid-warning" v-if="isValid == 2">
                Invalid phone number!
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="email"
                class="form-control"
                id="pEmail"
                :rules="[rules.required, rules.email]"
                v-model="pEmail"
                placeholder="Parent Email"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                :class="{ invalid: isValid == 3 }"
                id="usl"
                :rules="[rules.required]"
                v-model="usl"
                placeholder="USL #"
                @keyup="validateUSL(usl, 'uslOne')"
              ></v-text-field>
              <div class="invalid-warning" v-if="isValid == 3">
                Invalid USL number.
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                class="form-control"
                v-model="position"
                placeholder="Position"
                :rules="[rules.required]"
                :items="['None', 'Midfield', 'Attack', 'Defense', 'Goalie']"
              >
              </v-select>
              <div
                class="invalid-warning"
                v-if="position == 'None' || position == ''"
              >
                Please choose a position.
              </div>
            </v-col>
          </v-row>
          <v-row v-if="secondPlayer">
            <v-col><h4>Second Player</h4></v-col>
          </v-row>
          <v-row v-if="secondPlayer">
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="first"
                :rules="[rules.required]"
                v-model="secondFirst"
                placeholder="First Name"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                id="last"
                :rules="[rules.required]"
                v-model="secondLast"
                placeholder="Last Name"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="secondPlayer">
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                :class="{ invalid: isValid == 4 }"
                id="phone"
                :rules="[rules.required]"
                v-model="secondPhone"
                placeholder="Phone"
                @keyup="validatePhone(secondPhone, 'secondPhone')"
              >
              </v-text-field>
              <div class="invalid-warning" v-if="isValid == 4">
                Invalid phone number!
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="email"
                class="form-control"
                id="email"
                :rules="[rules.required, rules.email]"
                v-model="secondEmail"
                placeholder="Email"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="secondPlayer">
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                class="form-control"
                :class="{ invalid: isValid == 5 }"
                id="usl"
                :rules="[rules.required]"
                v-model="secondUsl"
                placeholder="USL # "
                @keyup="validateUSL(secondUsl, 'secondUsl')"
              >
              </v-text-field>
              <div class="invalid-warning" v-if="isValid == 5">
                Invalid USL number.
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                class="form-control"
                v-model="secondPosition"
                placeholder="Position"
                :rules="[rules.required]"
                :items="['None', 'Midfield', 'Attack', 'Defense', 'Goalie']"
              >
              </v-select>
              <div
                class="invalid-warning"
                v-if="secondPosition == 'None' || secondPosition == ''"
              >
                Please choose a position.
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <label for="second_player">Second player?</label>
              <input
                type="checkbox"
                class="form-control"
                id="second_player"
                v-model="secondPlayer"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-btn
                :disabled="!isFormValid"
                elevated
                class="submitBtn"
                type="submit"
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <!-- End Form-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
        position: (value) => value == "None" || "Please choose a position.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      first: "",
      last: "",
      phone: "",
      email: "",
      pFirst: "",
      pLast: "",
      pPhone: "",
      pEmail: "",
      usl: "",
      position: "",
      secondPlayer: false,
      validPhoneNumber: "",
      isValid: 0,
      secondFirst: "",
      secondLast: "",
      secondPhone: "",
      secondEmail: "",
      secondUsl: "",
      secondPosition: "",
      success: false,
      error: false,
      isFormValid: false,
    };
  },
  methods: {
    async submitForm() {
      // build arr of objs IF second player is checked
      if (this.position == "None" || this.secondPosition == "None") {
        return;
      }
      let respArr = [
        {
          Name: this.first + " " + this.last,
          Phone: this.phone,
          Email: this.email,
          ParentName: this.pFirst + " " + this.pLast,
          ParentPhone: this.pPhone,
          ParentEmail: this.pEmail,
          Position: this.position,
          USL: this.usl,
        },
      ];
      if (this.secondPlayer) {
        let sp = {
          Name: this.secondFirst + " " + this.secondLast,
          Phone: this.secondPhone,
          Email: this.secondEmail,
          ParentName: this.pFirst + " " + this.pLast,
          ParentPhone: this.pPhone,
          ParentEmail: this.pEmail,
          Position: this.secondPosition,
          USL: this.secondUsl,
        };
        respArr.push(sp);
      }

      let auth =
        "patbpbSOjPbU1dPfY.dcca4577fde5788d229f84671f9572d95304ec7c29a43d02d6b636264764c955";

      let Airtable = require("airtable");
      let base = new Airtable({ apiKey: auth }).base("appWwAV4AVxZI1Ane");

      for (let form of respArr) {
        // send form
        base("Responses 2024").create(form, function (err) {
          if (err) {
            console.error(err);
            this.error = true;
            return;
          }
        });
      }

      // success message
      if (this.error == false && this.secondPlayer) {
        this.success = true;
      }
      if (this.error == false && !this.secondPlayer) {
        this.success = true;
      }

      // Reset the title and description field values.
      this.first = "";
      this.last = "";
      this.phone = "";
      this.email = "";
      this.pFirst = "";
      this.pLast = "";
      this.pPhone = "";
      this.pEmail = "";
      this.usl = "";
      this.secondPlayer = false;
      this.secondFirst = "";
      this.secondLast = "";
      this.secondPhone = "";
      this.secondEmail = "";
      this.position = "";
      this.secondPosition = "";
      this.isFormValid = false;
    },

    validatePhone(number, field) {
      // toggle css instead of using vars
      const phoneRegex = /^\d{10}$/;
      let phoneCheck = number.match(phoneRegex);
      if (phoneCheck == null && number != "") {
        if (field == "phone") this.isValid = 1;
        if (field == "parent") this.isValid = 2;
        if (field == "secondPhone") this.isValid = 4;
      } else {
        this.isValid = 0;
      }
    },
    validateUSL(usl, field) {
      // same as with phone
      const uslRegex = /^\d{12}$/;
      let uslCheck = usl.match(uslRegex);
      if (uslCheck == null && usl != "") {
        if (field == "uslOne") this.isValid = 3;
        if (field == "secondUsl") this.isValid = 5;
      } else {
        this.isValid = 0;
      }
    },
  },
  created() {},
};
</script>

<style>
.resp_container {
  margin-top: 7vh;
  margin-right: 100px;
  margin-left: 100px;
}
.error-msg,
.success-msg {
  margin: 10px 0;
  padding: 10px;
  border-radius: 3px 3px 3px 3px;
}
.success-msg {
  color: #270;
  background-color: #dff2bf;
}

.error-msg {
  color: #d8000c;
  background-color: #ffbaba;
}

form {
  background-color: #fff;
}

label {
  font-size: 14px;
  color: gray;
}

input,
select {
  border: 0;
  padding: 0;
  z-index: 1;
  background-color: transparent;
  border-bottom: 2px solid #eee !important;
  font: inherit;
  font-size: 14px;
  line-height: 30px;
}

input[type="text"],
input[type="password"],
input[type="email"],
textarea,
select {
  outline: none;
}

.form-group {
  margin-bottom: 25px;
}

.submitBtn {
  background-color: #69e338 !important;
}

.invalid {
  border-bottom: 1px solid red !important;
}
.invalid-warning {
  margin: 10px auto;
  color: red;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  select {
    width: 44vw;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  select {
    width: 44vw;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  select {
    width: 16%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  select {
    width: 16%;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  select {
    width: 16%;
  }
}
</style>
